<template>
  <div class="summary white-box position-relative">
    <TileLoader :loading="loading"/>
    <h2>Mes rendez-vous</h2>
    <div class="appointments">
      <div class="today">
        <p class="title">Aujourd'hui</p>
        <ul>
          <li v-for="a of todaysAppointments" :key="a.Guid" :class="a.active ? 'active' : ''">
            <router-link :to="{path: '/dashboard-cdm/rdv', query: {frsGuid: a.Guid}}">
              <span> {{ dayjs(a.AppointmentDate).format("HH[h]mm") }} </span>
              <span>{{ a.Name }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="to-come">
        <p class="title">A venir</p>
        <ul>
          <li v-for="dayBlock of weekAppointmentsPerDay" :key="dayBlock.day">
            <span>{{ dayBlock.day }}</span>
            <ul v-if="dayBlock.appointments.length">
              <li v-for="a of dayBlock.appointments" :key="a.Guid">
                <router-link :to="{path: '/dashboard-cdm/rdv', query: {frsGuid: a.Guid}}">
                  {{ a.Name }}
                </router-link>
              </li>
            </ul>
            <div v-else class="text-muted">
              Aucun rdv
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import {getComingAppointments} from "@/utils/dashboardCdm";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import TileLoader from "../../Dashboards/TileLoader.vue";
import store from "@/store/dashboards";

export default {
  components: {
    TileLoader
  },
  data() {
    return {
      loading: true,
      appointments: [],
      store
    }
  },
  mounted() {
    this.initData()
  },
  watch: {
    storeGlobalView() {
      this.initData();
    }
  },
  methods: {
    initData() {
      this.loading = true;

      getComingAppointments(this.storeGlobalView).then(res => {
        res = res.sort((a, b) => dayjs(a.AppointmentDate).unix() - dayjs(b.AppointmentDate).unix())

        this.appointments = res;
        this.updateActiveAppointment();
        // On update toutes les minutes;
        window.setInterval(() => {
          this.updateActiveAppointment();
        }, 1000 * 60)

        this.loading = false;
      })
    },
    updateActiveAppointment() {
      let now = dayjs();

      for (let i = 0; i < this.appointments.length; i++) {
        let appointment = this.appointments[i];
        let nextAppointment = i < this.appointments.length - 1 ? this.appointments[i + 1] : null;
        if (now.isAfter(dayjs(appointment.AppointmentDate).subtract(30, "minutes")) && (
          !nextAppointment ||
          now.isBefore(dayjs(nextAppointment.AppointmentDate).subtract(30, "minutes"))
        )) {
          appointment.active = true;
        } else {
          appointment.active = false;
        }
      }
    }
  },
  computed: {
    dayjs() {
      return dayjs
    },
    storeGlobalView() {
      return this.store.globalView;
    },
    todaysAppointments() {
      return this.appointments.slice().filter(a => {
        let date = dayjs(a.AppointmentDate);
        let now = dayjs();

        return date.isSame(now, "day");
      });
    },
    weekAppointmentsPerDay() {
      let daysLabels = {
        0: "Dimanche",
        1: "Lundi",
        2: "Mardi",
        3: "Mercredi",
        4: "Jeudi",
        5: "Vendredi",
        6: "Samedi"
      }
      let today = dayjs();
      let result = [];

      for (let i = 1; i < 8; i++) {
        let date = today.add(i, "day");
        if (date.day() === 0 || date.day() === 6) continue;
        let appointmentsOfDay = this.appointments.slice().filter(a => {
          let _date = dayjs(a.AppointmentDate);
          return _date.isSame(date, "day");
        });

        result.push({
          day: daysLabels[date.day()],
          appointments: appointmentsOfDay || []
        })
      }

      return result;
    }
  }
}

</script>

<style scoped>

.white-box {
  flex: 1 1 35em;
}

h2 {
  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

.appointments {
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-height: 23em;
  overflow-y: auto;
}

.appointments .title {
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  padding: 4px 0;
  text-align: center;
}

.appointments ul {
  list-style: none;
  padding: 0 12px;
  margin: 0;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}

.appointments .today {
  border-right: 1px solid #ccc;
}

.appointments .today li {
  padding: 1px 0;
}

.appointments .today li.active {
  font-size: 1.3em;
  border-bottom: 1px solid #A7C13C;
}

.appointments .today li > a {
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  display: flex;
  justify-content: space-between;
  column-gap: 24px;
}

.appointments .today li > a span:last-child {
  text-align: right;
}

.appointments .to-come > ul {
  row-gap: 16px;
}

.appointments .to-come > ul > li {
  border-top: 1px solid #CECECE;
  padding: 1px 0;
  display: flex;
  justify-content: space-between;
  column-gap: 24px;
}

.appointments .to-come > ul ul {
  padding: 0;
  row-gap: 2px;
}

.appointments .to-come > ul li ul li {
  display: block;
  text-align: right;
}

.appointments .to-come > ul a {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardCdm/Appointments/AppointmentsTile.vue